import { computed, ref, watch } from '@vue/composition-api'
import { debounce } from 'lodash'
import useRequest from '@/compositions/useRequest'
import useForm from '@/compositions/useForm'
import DatePicker from '@/components/DatePicker/DatePicker'
import {
  required, isNotDecimal, isPositive, requiredIf,
} from '@/utils/validations'


const renewalTypes = {
  days: 'days',
  hours: 'hours',
}

const radioOptions = [
  { label: 'Добавить дни аренды', value: renewalTypes.days },
  { label: 'Продлить в рамках периода аренды', value: renewalTypes.hours },
]

export default {
  components: { DatePicker },
  props: {
    orderId: Number,
    extensionType: String,
    dates: Array,
  },

  setup(props, context) {
    const { emit } = context
    const { $store } = context.root

    const selectedType = ref(renewalTypes.days)
    const increasedPrice = ref('')
    const totalPrice = ref('')

    const { makeRequest } = useRequest({
      context,
      request: data => $store.dispatch('orders/extension', { id: props.orderId, data }),
      successMessage: 'Запрос на продление аренды отправлен!',
    })

    const fetchPrice = useRequest({
      context,
      request: machineHours => $store.dispatch('orders/getPrice', { id: props.orderId, machineHours }),
    })

    const debouncedFetchPrice = debounce(async (machineHours) => {
      const { increase, total } = await fetchPrice.makeRequest(machineHours)
      increasedPrice.value = increase
      totalPrice.value = total
    }, 500)

    const {
      validate, $errors, formData, reset,
    } = useForm({
      reactive: true,
      fields: {
        additionalDays: { default: '', validations: { required: requiredIf(() => selectedType.value === renewalTypes.days), isPositive, isNotDecimal } },
        additionalMachineHours: { default: '', validations: { required, isPositive, isNotDecimal } },
      },
    })

    const cancel = () => {
      emit('cancel')
    }
    const submit = async () => {
      if (!validate()) return

      const data = {}

      if (selectedType.value === renewalTypes.days) {
        data.additionalDays = formData.additionalDays.value
      }
      data.additionalMachineHours = formData.additionalMachineHours.value

      await makeRequest(data)
      reset()
      emit('update')
    }

    watch(() => formData.additionalDays.value, (newVale) => {
      formData.additionalMachineHours.value = +newVale * 8
    })

    watch(() => formData.additionalMachineHours.value, (value) => {
      if (!validate()) return
      debouncedFetchPrice(value)
    })

    return {
      formData,
      $errors,
      submit,
      selectedType,
      renewalTypes,
      radioOptions,
      cancel,
      increasedPrice: computed(() => increasedPrice.value.toLocaleString('ru-RU', { currency: 'RUB' })),
      totalPrice: computed(() => totalPrice.value.toLocaleString('ru-RU', { currency: 'RUB' })),
    }
  },
}
